/**
 * @generated SignedSource<<665fea4eb86fc5d6330d46d29aa04f66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPublicProfileEditableMedia_publicProfile$data = {
  readonly avatarImage: {
    readonly parent: {
      readonly serviceId: string | null;
    } | null;
    readonly path: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly bio: string | null;
  readonly discordLink: string | null;
  readonly displayName: string | null;
  readonly facebookLink: string | null;
  readonly heroImage: {
    readonly parent: {
      readonly serviceId: string | null;
    } | null;
    readonly path: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly instagramLink: string | null;
  readonly twitterLink: string | null;
  readonly userId: string | null;
  readonly username: string | null;
  readonly webLink: string | null;
  readonly wikipediaLink: string | null;
  readonly " $fragmentType": "NftPublicProfileEditableMedia_publicProfile";
};
export type NftPublicProfileEditableMedia_publicProfile$key = {
  readonly " $data"?: NftPublicProfileEditableMedia_publicProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileEditableMedia_publicProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "path",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Photo",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPublicProfileEditableMedia_publicProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "heroImage",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discordLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wikipediaLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitterLink",
      "storageKey": null
    }
  ],
  "type": "PublicProfile",
  "abstractKey": null
};
})();

(node as any).hash = "0c1c8f9cb2eae40acee3234e9cb9b3f4";

export default node;
